import React from "react";
import "../style.css";

const hotelPartners = [
  {
    city: "Varanasi",
    image: "https://images.unsplash.com/photo-1588416936097-41850ab3d86d",
    hotels: [
      "The Elegance",
      "Rio Benaras",
      "Dev Residency",
      "Hotel Vanshi Vat",
      "Hotel Veda",
      "Hotel Ganges Grand"
    ]
  },
  {
    city: "Prayagraj",
    image: "https://optimatravels.com/images/allahabad-images/triveni-sangam-prayagraj.webp",
    hotels: [
      "The Elegance",
      "Rio Benaras",
      "Dev Residency",
      "Hotel Vanshi Vat",
      "Hotel Veda",
      "Hotel Ganges Grand"
    ]
  },
  {
    city: "Ayodhya",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Ayodhya_Ram_Mandir_Inauguration_Day_Picture.jpg/330px-Ayodhya_Ram_Mandir_Inauguration_Day_Picture.jpg",
    hotels: [
      "The Elegance",
      "Rio Benaras",
      "Dev Residency",
      "Hotel Vanshi Vat",
      "Hotel Veda",
      "Hotel Ganges Grand"
    ]
  },
  {
    city: "Gaya / Bodhgaya",
    image: "https://images.unsplash.com/photo-1611143669185-af224c5e3252",
    hotels: [
      "The Elegance",
      "Rio Benaras",
      "Dev Residency",
      "Hotel Vanshi Vat",
      "Hotel Veda",
      "Hotel Ganges Grand"
    ]
  }
];

const Outstation = () => {
  return (
    <section className="stay-section">
      <div className="stay-container">

        {/* Header */}
        <div className="stay-header">
          <h2>Stay & Travel Excellence</h2>
          <p>
            Outstation <span>& Accommodations.</span>
          </p>
        </div>

        {/* Travel Description with Image */}
        <div className="stay-info">
          <div className="stay-text">
            <p>
              VNS Tour And Travels offers safe, reliable, and comfortable rides for locals,
              tourists, and business travelers. Whether you need airport transfers from
              Babatpur or local rides across the city, we ensure timely pickup and drop.
            </p>

            <p>
              From local trips to intercity journeys, book sightseeing rides to
              Kashi Vishwanath Temple, Sarnath, Ganga Aarti or business trips to
              Prayagraj, Ayodhya, and Gaya.
            </p>

            <blockquote>
              “Customer satisfaction comes first. Our 24/7 support team and experienced
              drivers ensure a smooth and stress-free journey.”
            </blockquote>
          </div>

          <div className="stay-image">
            <img
              src="https://images.unsplash.com/photo-1593693397690-362cb9666fc2"
              alt="VNS Tour And Travels "
            />
          </div>
        </div>

        {/* Hotel Partners */}
        <div className="partner-section">
          <h3>Official Travel Partner</h3>
          <p className="partner-subtitle">
            Curated luxury and comfort at every destination.
          </p>

          <div className="partner-grid">
            {hotelPartners.map((item, index) => (
              <div className="partner-card" key={index}>
                <img src={item.image} alt={item.city} />
                <div className="partner-content">
                  <h4>{item.city}</h4>
                  <ul>
                    {item.hotels.map((hotel, i) => (
                      <li key={i}>{hotel}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="stay-cta">
          <h3>Modern Travel Experience</h3>
          <h2>Your Dependable Travel Partner in Kashi.</h2>

          <div className="cta-actions">
            <a href="tel:+91 6307291567" className="cta-call">
              Call +91 6307291567
            </a>
            <button className="cta-quote">
              Get Custom Quote
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Outstation;
